"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SuspenseContext = void 0;
var _react = _interopRequireDefault(require("react"));
var _client = require("@apollo/client");
// useSuspenseQuery and useQuery have slightly different response shapes.
// This manually combines them so that users can access fields on either without
// needing operator narrowing.

const SuspenseContext = exports.SuspenseContext = /*#__PURE__*/_react.default.createContext({
  maybeUseSuspenseQuery: _client.useQuery
});